import constants from "../constants.js";

//LimitPassengerPolicy

const EnhancedPolicyRulesLimitPassengerEnablePassengerLimit = {
    displayName: "Enable Limit Passenger Policy",
    dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.IsEnabled",
    displayAs: constants.DISPLAY_AS.BOOLEAN,
  };
  
const EnhancedPolicyRulesLimitPassengerFlightConfigurationPassengerLimit = {
  displayName: "Limit Count",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.LimitCount",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

//LimitPassengerPolicy-DebtorIdentification

const EnhancedPolicyRulesLimitPassengerDebtorIdentificationType = {
  displayName: "Type",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.DebtorIdentification.DebtorIdentificationType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DebtorIdentificationType",
  hideShowProperty: "DebtorIdentificationType"
};

const EnhancedPolicyRulesLimitPassengerDebtorIdentificationDefinedDks = {
  displayName: "DefinedDks",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.DebtorIdentification.DefinedDks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  formClass: "DebtorIdentificationType_DefinedDks"
};

const EnhancedPolicyRulesLimitPassengerDebtorIdentificationGroupCodeValue = {
  displayName: "GroupCodeValue",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.DebtorIdentification.GroupCodeValue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "DebtorIdentificationType_DefinedGroupCode"
};

//LimitPassengerPolicy-UdidConfigurations

const EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationType = {
  displayName: "Type",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.UdidType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "UdidConfigurationType",
  hideShowProperty: "UdidConfigurationType"
};

const EnhancedPolicyRulesLimitPassengerPolicyUdidStaticPreTripCode = {
  displayName: "PreTripCode",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.PreTripCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "UdidConfigurationType_StaticUdid"
};

const EnhancedPolicyRulesLimitPassengerPolicyUdidStaticValue = {
  displayName: "Value",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.Value",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "UdidConfigurationType_StaticUdid"
};

const EnhancedPolicyRulesLimitPassengerPolicyUdidCompanyReferencePreTripCode = {
  displayName: "PreTripCode",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.PreTripCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "UdidConfigurationType_CompanyReference"
};
 
const EnhancedPolicyRulesLimitPassengerPolicyUdidCompanyReferenceCompanyRefCode = {
  displayName: "Code",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.Value",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "UdidConfigurationType_CompanyReference"
};
 
const EnhancedPolicyRulesLimitPassengerPolicyUdidAgencyReasonCodePreTripCode = {
  displayName: "PreTripCode",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.PreTripCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "UdidConfigurationType_AgencyReasonCode"
};

export const EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem = {
  displayName: "Uuid Configuration",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
      EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationType,
      EnhancedPolicyRulesLimitPassengerPolicyUdidStaticPreTripCode,
      EnhancedPolicyRulesLimitPassengerPolicyUdidStaticValue,
      EnhancedPolicyRulesLimitPassengerPolicyUdidCompanyReferencePreTripCode,
      EnhancedPolicyRulesLimitPassengerPolicyUdidCompanyReferenceCompanyRefCode,
      EnhancedPolicyRulesLimitPassengerPolicyUdidAgencyReasonCodePreTripCode
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem",
  canDelete: true
};
  
const EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsGrid = {
  displayName: "Udid Configurations",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: false,
  canAddNew: true,
  gridItem: EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem,
  gridCols: [
   { name: "Type", key: "UdidType" },
   { name: "PreTripCode", key: "PreTripCode" },
   { name: "Value", key: "Value" }
  ]
};
  
//LimitPassengerPolicy-PolicyRestriction
  
const EnhancedPolicyRulesLimitPassengerPolicyRestrictiontionRestrictionType = {
  displayName: "Type",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.RestrictionType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "PolicyRestrictionType",
  hideShowProperty: "PolicyRestrictionType"
};

const EnhancedPolicyRulesLimitPassengerPolicyRestrictionShowButNotAllowMessage = {
  displayName: "Message",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  formClass: "PolicyRestrictionType_ShowButNotAllow"
};
  
const EnhancedPolicyRulesLimitPassengerPolicyRestrictionDisplayMessageTitle = {
  displayName: "Title",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "PolicyRestrictionType_MessagePopup"
};
 
const EnhancedPolicyRulesLimitPassengerPolicyRestrictionDisplayMessage = {
  displayName: "Message",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  formClass: "PolicyRestrictionType_MessagePopup"
};

const EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyMessage = {
  displayName: "Message",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  formClass: "PolicyRestrictionType_PolicyViolation"
};
 
const EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyListId = {
  displayName: "ListId",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.PolicyViolation.ListId",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "PolicyRestrictionType_PolicyViolation",
  html: "Company Reference ListId to pull option values to choose from."
};
 
const EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyRemarkFormat = {
  displayName: "RemarkFormat",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.PolicyViolation.RemarkFormat",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "PolicyRestrictionType_PolicyViolation",
  html: "Smart.Format used to write remark to booking.<br/>Exmple: .S*UD110 VIOLATION CODE {Value}<br/><i>Properties</i>" 
  + "<ul><li>ValueDescription</li><li>Value</li></ul>"
};

export const EnhancedPolicyRulesActionsLimitPassengerItem = {
  displayName: "Actions Limit Passenger",
  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
      EnhancedPolicyRulesLimitPassengerEnablePassengerLimit,
      EnhancedPolicyRulesLimitPassengerFlightConfigurationPassengerLimit,,
      {
        displayAs: constants.DISPLAY_AS.SUB_HEADING,
        html:
          "<h4>Debtor Identification</h4>",
      },
      EnhancedPolicyRulesLimitPassengerDebtorIdentificationType,
      EnhancedPolicyRulesLimitPassengerDebtorIdentificationDefinedDks,
      EnhancedPolicyRulesLimitPassengerDebtorIdentificationGroupCodeValue,
      {
        displayAs: constants.DISPLAY_AS.SUB_HEADING,
        html:
          "<h4>Udid Configurations</h4>",
      },
      EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsGrid,
      {
        displayAs: constants.DISPLAY_AS.SUB_HEADING,
        html:
          "<h4>Policy Restrictions</h4>",
      },
      EnhancedPolicyRulesLimitPassengerPolicyRestrictiontionRestrictionType,
      EnhancedPolicyRulesLimitPassengerPolicyRestrictionDisplayMessageTitle,
      EnhancedPolicyRulesLimitPassengerPolicyRestrictionDisplayMessage,
      EnhancedPolicyRulesLimitPassengerPolicyRestrictionShowButNotAllowMessage,
      EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyMessage,
      EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyListId,
      EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyRemarkFormat
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesActionsLimitPassengerItem",
  canDelete: true,
};


// WEBPACK FOOTER //
// ./src/config/fields/enhancedPolicyRulesLimitPassenger.js